<template>
    <section class="experiment" :aria-label="itemData.title">
        <!-- Mobile title -->
        <h3 class="experiment__title  experiment__title--mobile">
            <a :href="itemData.repoUrl" target="_blank">{{ itemData.title }}</a>
        </h3>

        <!-- Image -->
        <div class="experiment__image">
            <responsive-image-reveal
                :responsiveImage="responsiveImage"
                :imageSizes="imageSizes"
                :imageAltText="itemData.title + ' logo'">
            </responsive-image-reveal>
        </div>

        <!-- Content container - START -->
        <div class="experiment__content">
            <!-- Desktop title -->
            <h3 class="experiment__title  experiment__title--desktop">
                <a :href="itemData.repoUrl" target="_blank">{{ itemData.title }}</a>
            </h3>

            <!-- Description -->
            <div class="experiment__description">
                <p v-for="(descriptionItem, descriptionIndex) in itemData.description"
                    :key="descriptionIndex"
                    v-html="descriptionItem">
                </p>
            </div>

            <!-- Links - START -->
            <div class="experiment__links">
                <p v-for="(linkData, linkIndex) in itemData.links" :key="linkIndex">
                    <a :href="linkData.url" target="_blank">
                        <icon name="angle-right"></icon>{{ linkData.text }}
                    </a>
                </p>

                <!-- Repo link -->
                <p>
                    <a :href="itemData.repoUrl" target="_blank">
                        <icon name="angle-right"></icon>View repo
                    </a>
                </p>
            </div>
            <!-- Links - END -->

        </div>
        <!-- Content container - END -->
    </section>
</template>

<script>
import breakpoints from '@/mixins/Breakpoints';
import icon from '@/components/Icon.vue';
import responsiveImageReveal from '@/components/ResponsiveImageReveal.vue';

export default {
    mixins: [breakpoints],
    props: {
        itemData: Object,
    },
    components: {
        icon,
        responsiveImageReveal,
    },
    computed: {
        // imageSizes - Generate a list of maximum image widths at each
        // breakpoint, this will be used in the 'sizes' attribute of the
        // 'srcset' for the image.
        imageSizes() {
            let imageSizes = '';

            imageSizes += `(min-width: ${this.breakpoints.sm}px) 100px, `; // sm - *
            imageSizes += '50px'; // 0 - sm

            return imageSizes;
        },

        // responsiveImage - Generate a responsive image object with the
        // specified widths including 2x retina.
        // Widths: 50, 100
        // Retina: 100, 200
        responsiveImage() {
            // eslint-disable-next-line max-len
            return require(`@/assets/img/experiments/${this.itemData.machineName}.png?sizes[]=50,sizes[]=100,sizes[]=200`);
        },
    },
};
</script>

<style lang="scss">
    .experiment {
        display: flex;
        flex-wrap: wrap;
        background-color: $color-smoke;
        border: solid 1px $color-smoke;
        padding: 1.7rem 2rem 1.5rem 2rem;

        @include mq($from: sm) {
            flex-wrap: nowrap;
        }

        @include mq($from: md) {
            padding: 2.5rem 3rem;
        }
    }

    .experiment__image {
        flex-shrink: 0;
        width: 5rem;

        @include mq($from: sm) {
            width: 10rem;
        }

        .image-reveal {
            border-radius: 50%;
        }
    }

    .experiment__content {
        flex-grow: 1;

        @include mq($from: sm) {
            padding-left: 3rem;
        }
    }

    .experiment__title {
        &.experiment__title--mobile {
            display: flex;
            align-items: center;
            width: calc(100% - 5rem);
            padding-right: 3rem;

            @include mq($from: sm) {
                display: none;
            }
        }

        &.experiment__title--desktop {
            display: none;

            @include mq($from: sm) {
                display: block;
            }
        }

        a {
            font-size: 1.8rem;
            text-decoration: none;

            &:hover {
                color: $color-primary;
            }

            @include mq($from: md) {
                font-size: 2.2rem;
            }
        }
    }

    .experiment__description {
        padding: 1.7rem 0 1.5rem 0;

        @include mq($from: md) {
            padding: 1.7rem 0 2.1rem 0;
        }
    }

    .experiment__links {
        a {
            display: inline-block;
            font-size: 1.4rem;
            font-weight: bold;
            line-height: 1;
            text-transform: uppercase;
            text-decoration: none;

            .icon {
                width: 1.4rem;
                height: 1.4rem;
                margin-left: -0.4rem;
            }
        }
    }
</style>
